import * as yup from 'yup';

export const studioNameRules = {
  max: 100,
  pattern: /^[A-Za-z0-9_-]*$/,
} as const;

export const MAX_DESCRIPTION_LENGTH = 256;

export const emrStudioSchema: yup.AnyObjectSchema = yup
  .object({
    name: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(studioNameRules.max, `Studio name should contain up to ${studioNameRules.max} characters`)
      .matches(studioNameRules.pattern, 'Only alphanumeric characters, underscore, and hyphen are allowed')
      .required('Studio name is a required field'),
    description: yup
      .string()
      .transform((v) => (typeof v === 'string' ? v.trim() : v))
      .max(MAX_DESCRIPTION_LENGTH, `Description should contain up to ${MAX_DESCRIPTION_LENGTH} characters`),
  })
  .required();
